import { render, staticRenderFns } from "./polygonRules.vue?vue&type=template&id=0e5695db&scoped=true"
import script from "./polygonRules.vue?vue&type=script&lang=js"
export * from "./polygonRules.vue?vue&type=script&lang=js"
import style0 from "./polygonRules.vue?vue&type=style&index=0&id=0e5695db&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5695db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5695db')) {
      api.createRecord('0e5695db', component.options)
    } else {
      api.reload('0e5695db', component.options)
    }
    module.hot.accept("./polygonRules.vue?vue&type=template&id=0e5695db&scoped=true", function () {
      api.rerender('0e5695db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/didi/rules/info/polygonRules.vue"
export default component.exports